import styled from 'styled-components';

import {
  LIGHT_GRAY,
  BLACK,
  ORANGE,
  BLUE,
} from 'root/theme';

const AnonScoreUpdateContainer = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const HeaderText = styled.h4`
  color: ${ORANGE};
  font-weight: bold;
  max-width: 30rem;
`;

const SubHeader = styled.div`
  color: ${BLACK};
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;
  width: 100%;
`;

const BarContainer = styled.div`
  background: ${LIGHT_GRAY};
  border: 2px solid ${LIGHT_GRAY};
  height: 1.5rem;
  width: 100%;
`;
const Bar = styled.div`
  background: ${ORANGE};
  height: 100%;
  width: ${(props) => props.width}%;
`;

const Username = styled.div`
  color: ${BLUE};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-weight: bold;
`;

const Progress = styled.div`
  color: ${ORANGE};
  display: flex;
  justify-content: flex-start;
`;


export {
  HeaderText,
  SubHeader,
  ContentContainer,
  AnonScoreUpdateContainer,
  BarContainer,
  Bar,
  Username,
  Progress,
};
